import { useEffect, useRef, useState } from 'react';
import { mergeRefs } from '@grupoboticario/flora-react-utils';
import { floraMessage } from '@grupoboticario/flora-react-utils';
export var useFloraSwitch = _ref => {
  var {
    id,
    label,
    'aria-label': ariaLabel,
    forwardedRef
  } = _ref;
  var internalRef = useRef(null);
  var [isChecked, setIsChecked] = useState(false);

  var handleInputChange = () => {
    if (internalRef.current) {
      setIsChecked(internalRef.current.checked);
    }
  };

  var handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();

      if (internalRef.current) {
        internalRef.current.checked = !internalRef.current.checked;
        setIsChecked(internalRef.current.checked);
        internalRef.current.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }
    }
  };

  useEffect(() => {
    if (label && ariaLabel && label !== ariaLabel) {
      floraMessage({
        type: 'log',
        category: 'accessibility',
        status: 'warn',
        message: "O switch com id " + id + " possui label e aria-label com valores diferentes. Utilize apenas um desses r\xF3tulos ou o mesmo valor em ambos."
      });
    }

    if (internalRef.current) {
      setIsChecked(internalRef.current.checked);
      internalRef.current.addEventListener('change', handleInputChange);
      internalRef.current.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      if (internalRef.current) {
        internalRef.current.removeEventListener('change', handleInputChange); // eslint-disable-next-line react-hooks/exhaustive-deps

        internalRef.current.removeEventListener('keydown', handleKeyDown);
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalRef.current, id, label, ariaLabel]);
  return {
    ref: mergeRefs(forwardedRef, internalRef),
    isChecked
  };
};
//# sourceMappingURL=useFloraSwitch.js.map